<template>
   <v-tour
      name="landingpage-tour"
      :options="options"
      :steps="steps" />
</template>

<script>
export default {
   name: 'LandingpageTour',

   data() {
      return {
         includeMoreToggle: false,
         wrapper: '',
         options: {
            highlight: true,
            debug: process.env.NODE_ENV !== 'production',
            enableScrolling: false,
            labels: {
               buttonSkip: 'Afslut',
               buttonPrevious: 'Forrige',
               buttonNext: 'Næste',
               buttonStop: 'Afslut',
            },
         },
      };
   },
   computed: {
      steps() {
         const steps = [
            {
               target: `${this.wrapper} .product-selectors`,
               content: 'Vælg først de forsikringer du ønsker tilbud på',
            },
         ];
         if (this.includeMoreToggle) {
            steps.push({
               target: `${this.wrapper} .product-selectors.intro .more-toggle`,
               content: 'Tryk her for at vise alle forsikringstyperne',
            });
         }
         steps.push({
            target: `${this.wrapper} .submit-products-btn`,
            content: 'Derefter kan du trykke her for at starte din forespørgsel',
         });
         return steps.map((step) => ({ ...step, params: { enableScrolling: false } }));
      },
   },
   mounted() {
      window.tour = this;
   },
   methods: {
      start(wrapper) {
         this.wrapper = wrapper;
         this.includeMoreToggle =
            document.querySelectorAll(`${this.wrapper} .product-selectors.intro .more-toggle`).length > 0;
         console.log('tour steps', this.steps);
         this.$tours['landingpage-tour'].start();
      },
   },
};
</script>

<style scoped></style>
